import { uniqBy } from 'lodash-es';
import { sortAlphabetically } from '~/infra/utils';
import { relationshipModel, timeModel } from '~/models';
import { isAdHoc } from '~/models/relationship-summary/selectors';
export function getGroupedAgreementOptions(agreements, clientId) {
    if (!clientId) return {
        agreements: [],
        adHocRelationships: []
    };
    const clientAgreements = agreements.filter((a)=>a.customer.id === clientId && !a.isSample);
    const signedAgreements = clientAgreements.filter((a)=>relationshipModel.isApproved(a)).sort((a, b)=>{
        var _ref, _ref1;
        var _a_effectiveDate, _b_effectiveDate;
        return ((_ref = (_a_effectiveDate = a.effectiveDate) === null || _a_effectiveDate === void 0 ? void 0 : _a_effectiveDate.getTime()) !== null && _ref !== void 0 ? _ref : 0) - ((_ref1 = (_b_effectiveDate = b.effectiveDate) === null || _b_effectiveDate === void 0 ? void 0 : _b_effectiveDate.getTime()) !== null && _ref1 !== void 0 ? _ref1 : 0);
    }).map((a)=>({
            id: a.id,
            text: a.title || (a.effectiveDate ? "unnamed (from ".concat(timeModel.formatDate(a.effectiveDate), ")") : 'unnamed')
        }));
    const adHocRelationships = clientAgreements.filter((a)=>isAdHoc(a)).map((a)=>({
            id: a.id
        }));
    return {
        agreements: signedAgreements,
        adHocRelationships
    };
}
export function getClientOptions(agreements) {
    const nonUnique = agreements.filter((a)=>!a.isSample).map((a)=>({
            id: a.customer.id,
            text: a.customer.name
        }));
    const unique = uniqBy(nonUnique, 'text');
    return sortAlphabetically(unique, 'text', {
        ascending: true,
        ignoreCase: true
    });
}
export function getDefaultRelationshipId(agreementOptions) {
    return agreementOptions[0] ? agreementOptions[0].id : '';
}
